import _find from 'lodash/find';
import _includes from 'lodash/includes';
import _reduce from 'lodash/reduce';
import _get from 'lodash/get';
import { getYear, sub } from 'date-fns';
import { STRINGS } from 'config';

const getPrefillData = (tags, questionId) => {
  const demographicTag = _find(tags, tag => _includes(STRINGS.TAGS.QUESTION.DEMOGRAPHICS, tag))
    || STRINGS.DEMOGRAPHIC_QUESTION_IDS_TO_TAGS[questionId];
  const prefillData = STRINGS.PREFILL_DATA[demographicTag];
  return { demographicTag, prefillData };
};

export const prefillDemographicData = ({ response, isClinicalReviewMode }) => {
  const prefillEnabled = STRINGS.PREFILL_ENABLED;
  const prefillClinicalReviewOnly = STRINGS.PREFILL_CLINICAL_REVIEW_ONLY;
  if (!prefillEnabled || (prefillClinicalReviewOnly && !isClinicalReviewMode)) {
    return {};
  }

  const { question } = response;
  const demographicsReadOnly = STRINGS.DEMOGRAPHICS_READONLY;

  switch (question.type) {
    case STRINGS.QUESTION_TYPE.DATE: {
      const { demographicTag } = getPrefillData(question.tags, question.questionId);
      let age = 0;
      if (demographicTag === STRINGS.TAGS.QUESTION.DEMOGRAPHICS.DATE_OF_BIRTH_ADULT) {
        age = 40;
      }
      if (demographicTag === STRINGS.TAGS.QUESTION.DEMOGRAPHICS.DATE_OF_BIRTH_PAED) {
        age = 16;
      }
      if (age > 0) {
        const year = `${getYear(sub(new Date(), { years: age }))}`;
        return {
          dateAnswer: {
            answerId: _get(question, 'answers[0].answerId', null),
            d: '01',
            m: '02',
            y: year,
            questionTags: question.tags || [],
          },
          inputsReadOnly: demographicsReadOnly,
        };
      }
      return {};
    }
    case STRINGS.QUESTION_TYPE.FREETEXT:
    case STRINGS.QUESTION_TYPE.FREETEXTSHORT: {
      const { prefillData } = getPrefillData(question.tags, question.questionId);
      if (_includes(question.tags, STRINGS.TAGS.QUESTION.DEMOGRAPHICS.POSTCODE)) {
        return { freeTextAnswer: prefillData, postcodeValidated: true };
      }
      return { freeTextAnswer: prefillData };
    }
    case STRINGS.QUESTION_TYPE.SINGLE: {
      const { prefillData } = getPrefillData(question.tags, question.questionId);
      const selectedAnswer = _find(question.answers, answer => answer.text === prefillData);
      if (selectedAnswer) {
        return { singleSelectedAnswer: selectedAnswer };
      }
      return {};
    }
    case STRINGS.QUESTION_TYPE.COMPOUND: {
      const compoundAnswers = _reduce(
        question.questions,
        (result, subQuestion) => {
          if (subQuestion.type === STRINGS.QUESTION_TYPE.COMPOUND) {
            const { compoundAnswers: nestedAnswers } = prefillDemographicData({ question: subQuestion });
            return { ...result, ...nestedAnswers };
          }
          let answerId = _get(subQuestion, 'answers[0].answerId', null);
          let value;
          if (subQuestion.type === STRINGS.QUESTION_TYPE.DATE) {
            const { demographicTag } = getPrefillData(subQuestion.tags, subQuestion.questionId);
            let age = 0;
            if (demographicTag === STRINGS.TAGS.QUESTION.DEMOGRAPHICS.DATE_OF_BIRTH_ADULT) {
              age = 40;
            }
            if (demographicTag === STRINGS.TAGS.QUESTION.DEMOGRAPHICS.DATE_OF_BIRTH_PAED) {
              age = 16;
            }
            if (age > 0) {
              const year = `${getYear(sub(new Date(), { years: age }))}`;
              value = { d: '01', m: '02', y: year };
            } else {
              value = {};
            }
          } else if (subQuestion.type === STRINGS.QUESTION_TYPE.SINGLE) {
            const { prefillData } = getPrefillData(subQuestion.tags, subQuestion.questionId);
            const selectedAnswer = _find(subQuestion.answers, answer => answer.text === prefillData);
            answerId = selectedAnswer.answerId;
            value = selectedAnswer;
          } else {
            const { prefillData } = getPrefillData(subQuestion.tags, subQuestion.questionId);
            value = prefillData;
          }
          return {
            ...result,
            [subQuestion.questionId]: {
              answerId,
              value,
              questionTags: subQuestion.tags || [],
            },
          };
        },
        {},
      );
      return { compoundAnswers, inputsReadOnly: demographicsReadOnly };
    }
    default:
      return {};
  }
};
